'use strict';

var templates = require('../templates');
var fobclient = require('..');
var PubIdentTyp = require('../entity').PubIdentTyp;

module.exports = function (connection) {
  return {
    byAnmerkungEquals: function byAnmerkungEquals(anmerkung, additionalParams) {
      return templates.searchTemplate(connection)(PubIdentTyp, 'byAnmerkungEquals', 'anmerkung')(anmerkung, additionalParams);
    },
    byAnmerkungLike: function byAnmerkungLike(anmerkung, additionalParams) {
      return templates.searchTemplate(connection)(PubIdentTyp, 'byAnmerkungLike', 'anmerkung')(anmerkung, additionalParams);
    },
    byKennungEquals: function byKennungEquals(kennung, additionalParams) {
      return templates.searchTemplate(connection)(PubIdentTyp, 'byKennungEquals', 'kennung')(kennung, additionalParams);
    },
    byKennungLike: function byKennungLike(kennung, additionalParams) {
      return templates.searchTemplate(connection)(PubIdentTyp, 'byKennungLike', 'kennung')(kennung, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(PubIdentTyp, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(PubIdentTyp, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('pubidenttyp')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/pubIdentTyp.js
// module id = wc1v
// module chunks = 0